var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgUnstoppabledomains = function SvgUnstoppabledomains(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 2.47278V13.3668L0 26.2392L32 2.47278Z",
    fill: "#00C9FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.001 2V20.7929C26.001 23.4191 24.9474 25.9378 23.0719 27.7948C21.1964 29.6519 18.6527 30.6951 16.0004 30.6951C13.3481 30.6951 10.8044 29.6519 8.92887 27.7948C7.05339 25.9378 5.99976 23.4191 5.99976 20.7929V12.8741L11.9991 9.60487V20.7929C11.943 21.2811 11.9916 21.7757 12.1418 22.244C12.2922 22.7124 12.5406 23.144 12.8711 23.5107C13.2016 23.8773 13.6066 24.1707 14.0596 24.3715C14.5126 24.5724 15.0033 24.6763 15.4996 24.6763C15.9959 24.6763 16.4866 24.5724 16.9396 24.3715C17.3925 24.1707 17.7976 23.8773 18.128 23.5107C18.4585 23.144 18.7071 22.7124 18.8573 22.244C19.0076 21.7757 19.0563 21.2811 19 20.7929V5.79246L26.001 2Z",
    fill: "#0D67FE"
  })));
};

export { SvgUnstoppabledomains as ReactComponent };
export default __webpack_public_path__ + "791b127c95b7677be2ce91af0de0c779.svg";